var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"years is-flex wrap"},_vm._l((_vm.years),function(option,index){return _c('router-link',{key:index,staticClass:"button has-no-underline",class:{ 'active' : option.year === _vm.schoolYear},attrs:{"to":{
      path: _vm.path,
      query: Object.assign({}, {locationGroupId: _vm.locationGroupId,
        schoolYear: option.year},
        _vm.queryParams),
    },"disabled":_vm.disableYears,"replace":""}},[_vm._v("\n    "+_vm._s(option.year-1)+"-"+_vm._s(option.year.toString(10).substring(2,4))+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }